import React, { useMemo } from 'react';
import type { FragmentType } from '@graphql/reactQuery';
import { FeedActivityTypePostFragmentDoc, getFragment, gql } from '@graphql/reactQuery';
import { DELETED_POST_MESSAGE } from '@utils/constants';
import { Repost } from '../Repost';
import { PostItem } from './PostItem';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment FeedActivityTypePost on UserCreatedPostAggregate {
    post {
      __typename
      id
      webappUri
      commentCount
      creator {
        id
        ...FeedActivityItemUserInfo
      }
      ...PostGroupItem

      ... on Repost {
        id
        ...RepostSource
        ...OriginalPostInfo
        creator {
          id
          username
          webappUri
        }
        originalPost {
          __typename
          id
          webappUri

          createdAt
          commentCount

          creator {
            id
            ...FeedActivityItemUserInfo
          }

          ...PostItemRepostSource
          ...OriginalPostInfo
        }
      }
    }
  }
`);

export function FeedActivityTypePost({
  activityFrag,
  timeStamp,
}: {
  activityFrag: FragmentType<FeedActivityTypePostFragmentDoc>;
  timeStamp: number;
}) {
  const { post } = getFragment(FeedActivityTypePostFragmentDoc, activityFrag);

  const originalPostCreatedAt = post?.__typename === 'Repost' ? post.originalPost?.createdAt : null;

  const originalTimeStamp = useMemo(
    () => new Date(originalPostCreatedAt ?? timeStamp).getTime(),
    [originalPostCreatedAt, timeStamp],
  );

  if (!post) {
    return <div className="text-base-s text-neutral400">{DELETED_POST_MESSAGE}</div>;
  }

  if (post.__typename === 'Repost') {
    if (post.originalPost == null) {
      return <div className="text-base-s text-neutral400">{DELETED_POST_MESSAGE}</div>;
    }

    return (
      <Repost
        originalPost={post.originalPost}
        originalTimeStamp={originalTimeStamp}
        repostSource={post}
      />
    );
  }

  return (
    <PostItem
      creator={post.creator}
      post={post}
      postId={post.id}
      timeStamp={timeStamp}
      webappUri={post.webappUri}
      repostSource={null}
    />
  );
}
